import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';

export const elementCommonStyles = css`
	padding: 16px;
	border: 1px solid ${colors.background};
	border-radius: 4px;
	border-top: none;
	border-top-left-radius: unset;
	border-top-right-radius: unset;
`;
